var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SalesList',{attrs:{"data":_vm.customerSales,"loading":_vm.loading,"date":"absolute","showCustomerColumn":false,"highlightToday":true,"data-qa":"customer-sales"}})
}
var staticRenderFns = []

export { render, staticRenderFns }